import FilterBarFilters from '@modules/search/components/search-filter-section/FilterBarFilters';
import type { OptionResult } from '@modules/search/components/search-filter-section/RoccoBasedSearchSort';
import SearchSort from '@modules/search/components/search-filter-section/RoccoBasedSearchSort';
import { useSearchSortOptions } from '~/modules/search/hook/use-search-sort-options';
import type { CategoryFilterSectionProps } from './CategoryFilterSection';

export const CategoryFilterSection = ({
    category,
    componentBefore,
    componentBarAddon,
    searchFilters,
}: CategoryFilterSectionProps) => {
    const { filterBarFilters, updateFilter, filterStates } = searchFilters;
    const optionResult = useSearchSortOptions({ category });

    return (
        <div className="flex items-center justify-between px-12.5 pb-6">
            {componentBefore}
            <div className="flex items-center justify-end gap-x-4">
                {(componentBarAddon ||
                    (filterBarFilters && filterBarFilters.length > 0)) && (
                    <FilterBarFilters
                        filters={filterBarFilters ?? []}
                        updateFilter={updateFilter}
                        componentBarAddon={componentBarAddon}
                        filterStates={filterStates}
                    />
                )}

                {optionResult.items.length > 0 && (
                    <SearchSort optionResult={optionResult as OptionResult} />
                )}
            </div>
        </div>
    );
};
